import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import {
  HvGrid,
  HvCheckBox,
  HvTypography,
  HvInput,
} from "@hitachivantara/uikit-react-core";

import { useFormikContext } from "formik";
import useStyles from "./styles";

interface VMSProps {
  mode: string;
}

const VMSTypeContent: React.FC<VMSProps> = () => {
  const { t } = useTranslation("cameraAddEdit");
  const classes = useStyles();
  const { values, setFieldTouched, setFieldValue, setStatus, errors, touched } =
    useFormikContext<CameraDetailsFormData>();

  const parseStatus = (field: keyof CameraDetailsFormData) => {
    return errors[field] && touched[field] ? "invalid" : "valid";
  };

  const parseStatusMessage = (field: keyof CameraDetailsFormData) => {
    return errors[field] ? errors[field] : "";
  };

  const setValueOnForm = useCallback(
    (property: string, selection: unknown) => {
      setFieldValue(property, selection);
      // clearServerSideErrors
      setStatus({});
    },
    [setFieldValue, setStatus]
  );
  return values.vmsHasPlayback ? (
    <HvGrid
      className={clsx(classes.root, classes.fields)}
      container
      item
      xs={12}
    >
      <HvGrid xs={6} md={3} className={classes.gridPaddingOverRide}>
        <HvTypography
          variant="highlightText"
          className={classes.cameraSpecificities}
          paragraph
        >
          {t("cameraType.fields.cameraSpecificities")}
        </HvTypography>
        <HvCheckBox
          label={t("cameraType.fields.recording")}
          value={values.recording || false}
          checked={values.recording || false}
          disabled={
            values.canPlayback !== null && values.canPlayback !== undefined
          }
          onBlur={() => setFieldTouched("recording", true, false)}
          onChange={(evt, value) => setValueOnForm("recording", value)}
        />
      </HvGrid>
      {values.vmsFPSPlayback ? (
        <HvGrid xs={6} md={3} className={classes.gridPaddingOverRide}>
          <HvInput
            className={classes.input}
            type="number"
            label={t("cameraType.fields.fps")}
            placeholder={t("cameraType.fields.fpsPlaceholder")}
            value={values.intFpsValue}
            disabled={!values.recording}
            status={parseStatus("intFpsValue")}
            statusMessage={parseStatusMessage("intFpsValue")}
            onBlur={() => setFieldTouched("intFpsValue", true, false)}
            onChange={(evt, value) => {
              setFieldValue("intFpsValue", value);
            }}
          />
        </HvGrid>
      ) : (
        <></>
      )}
    </HvGrid>
  ) : (
    <></>
  );
};

export default VMSTypeContent;
